import { API_BASE } from "./siteConfig";
import axios from "axios";

// Endereço da API vem de lib/siteConfig.js (localhost no PC, /api no pkxidle.com)
const BASE_URL = API_BASE;

// Autorização apenas por JWT (interceptor abaixo); nenhuma chave compartilhada no cliente
export const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("pokeot_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Erros de validação do servidor (422) chegam como LISTA de objetos. Vários telas fazem toast.error(detail): um objeto/lista dentro do React
// derrubava a página inteira ("tela preta"). Aqui a lista vira UMA frase em português. (Objetos com "message"/"code" — nome repetido, e-mail
// a confirmar — continuam como estão: as telas de login/cadastro tratam esses.)
const CAMPOS = {
  email: "E-mail inválido: confira o endereço.",
  username: "Nome da conta: de 3 a 24 caracteres, só letras, números, _ . e - (sem espaços).",
  password: "Senha: use pelo menos 8 caracteres.",
  new_password: "Nova senha: use pelo menos 8 caracteres.",
  name: "Nome do personagem: de 2 a 24 caracteres.",
  code: "Código inválido: digite os 6 dígitos.",
};
function frasePydantic(e) {
  const loc = Array.isArray(e && e.loc) ? e.loc : [];
  for (let i = loc.length - 1; i >= 0; i--) if (CAMPOS[loc[i]]) return CAMPOS[loc[i]];
  const campo = loc.filter((x) => x !== "body").join(".");
  return (campo ? campo + ": " : "") + String((e && e.msg) || "valor inválido");
}
api.interceptors.response.use(
  (r) => r,
  (err) => {
    try {
      const d = err && err.response && err.response.data && err.response.data.detail;
      if (Array.isArray(d)) err.response.data.detail = d.map(frasePydantic).filter((v, i, a) => a.indexOf(v) === i).join(" ");
      else if (d && typeof d === "object" && !d.message && !d.code) err.response.data.detail = d.msg ? String(d.msg) : "Pedido inválido.";
    } catch (e) { /* mantém o erro original */ }
    return Promise.reject(err);
  }
);
